import { render, staticRenderFns } from "./Walkups.vue?vue&type=template&id=5727bd4c&scoped=true&"
import script from "./Walkups.vue?vue&type=script&lang=js&"
export * from "./Walkups.vue?vue&type=script&lang=js&"
import style0 from "./Walkups.vue?vue&type=style&index=0&id=5727bd4c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5727bd4c",
  null
  
)

export default component.exports